// eSIM aktif/pasif kararının TEK kaynağı: backend'in döndürdüğü V2
// `displayStatus` alanı. Başka hiçbir alandan (orderStatus, providerStatus,
// tarihler, remainingDays) durum TÜRETİLMEZ — kural backend'de yaşar.
// Ayrıntı: src/services/MY_ESIMS_V2_API.md

export const DISPLAY_STATUS = {
  ACTIVE: 'ACTIVE',
  READY_TO_USE: 'READY_TO_USE',
  INACTIVE: 'INACTIVE',
  STATUS_UNAVAILABLE: 'STATUS_UNAVAILABLE',
};

const KNOWN = new Set(Object.values(DISPLAY_STATUS));

// Tanınmayan/boş bir değeri kırılmadan STATUS_UNAVAILABLE gibi ele al.
export const normalizeStatus = (raw) =>
  KNOWN.has(raw) ? raw : DISPLAY_STATUS.STATUS_UNAVAILABLE;

const statusOf = (esim) => normalizeStatus(esim?.displayStatus);

// Sekme ataması: yalnızca INACTIVE pasiftir. STATUS_UNAVAILABLE dahil
// diğer her şey aktif tarafta kalır (pasif SAYILMAZ).
export const isInactive = (esim) => statusOf(esim) === DISPLAY_STATUS.INACTIVE;

// READY_TO_USE'da veri/gün sayaçları 0 gelir ve "bitti" anlamına GELMEZ;
// süre henüz başlamadığı için sayaçları gizleyip paket bilgisini gösteririz.
export const isReadyToUse = (esim) =>
  statusOf(esim) === DISPLAY_STATUS.READY_TO_USE;

export const isStatusUnavailable = (esim) =>
  statusOf(esim) === DISPLAY_STATUS.STATUS_UNAVAILABLE;

// Rozet için i18n anahtarı + renk sınıfı (account.css: .status--*).
const STATUS_UI = {
  [DISPLAY_STATUS.ACTIVE]: { key: 'esimStatus.active', cls: 'active' },
  [DISPLAY_STATUS.READY_TO_USE]: { key: 'esimStatus.readyToUse', cls: 'info' },
  [DISPLAY_STATUS.INACTIVE]: { key: 'esimStatus.inactive', cls: 'passive' },
  [DISPLAY_STATUS.STATUS_UNAVAILABLE]: { key: 'esimStatus.unavailable', cls: 'unknown' },
};

export const statusUi = (esim) => STATUS_UI[statusOf(esim)];
